import React, { useState, useEffect } from "react";

import styled from "styled-components";

import CircularProgress from "@mui/material/CircularProgress";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Loader = ({ isInnerLoad }) => {
  const style = isInnerLoad
    ? { width: "100%", height: "100%" }
    : {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        top: 0,
        left: 0,
        zIndex: 10000,
        background: "#fff",
      };

  return (
    <Container style={style}>
      <CircularProgress className="color-primary" />
    </Container>
  );
};

export default Loader;
